export default "/images/real_express.svg?a2c7c4d413ce29b4d2fa653692ee0525";